var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"move-box"},[_c('div',{staticClass:"table-right-line",style:({ left: _vm.left - 3 + 'px' }),on:{"mousedown":_vm.rightLineMouseDown}}),_c('div',{ref:"move-line",staticClass:"move-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }